import ApiClient from 'clients/api_client'
import InternalScout from 'entities/cooperation/internal_scout'

export default class InternalScoutClient {
  static post(formData) {
    const url = Routes.internalScoutsPath()
    return ApiClient.post(url, formData).then(({ data }) => new InternalScout(data))
  }
}
